module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.navType,
    attrs: {
      "id": "Nav"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.historyBack),
      expression: "!historyBack"
    }],
    staticClass: "back-icon"
  }, [_c('a', {
    attrs: {
      "href": _vm.schemeUrl + '://'
    }
  }, [_c('img', {
    staticClass: "back-img",
    attrs: {
      "src": require("../../assets/icon/image_nav_back_arrow@3x.png")
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.historyBack),
      expression: "historyBack"
    }],
    staticClass: "history-back",
    on: {
      "click": _vm.goBack
    }
  }, [_c('img', {
    staticClass: "back-img",
    attrs: {
      "src": require("../../assets/icon/image_nav_back_arrow@3x.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('img', {
    staticClass: "user-img",
    attrs: {
      "src": _vm.userImg
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(this.titleName))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.coinShow),
      expression: "coinShow"
    }],
    staticClass: "userCoins"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icon/image_gx_coins@3x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userCoins))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collectShow),
      expression: "collectShow"
    }],
    staticClass: "collect",
    on: {
      "click": _vm.addHome
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icon/image_nav_collect@3x.png"),
      "alt": ""
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f86772d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/TopBar.vue
// module id = 264
// module chunks = 18